<template>
  <div class="create-link-wizard">
    <div @click="close()" class="close">
      <CloseIcon />
      <span class="close-text">ESC</span>
    </div>
    <div class="wizard-sidebar">
      <div class="progress">
        <div class="link-type" :class="{ active: currentStep === 1 }">
          <div class="icon-and-text">
            <div class="icon-container">
              <div class="icon-wrapper">
                <EditIcon />
              </div>
            </div>
            <span>Link Type</span>
          </div>
          <div class="separator"></div>
        </div>
        <template v-if="createLinkWizardData.link_type === 'pre-release'">
          <div
            class="link-type pre-date"
            :class="{ active: currentStep === 2 }"
          >
            <div class="icon-and-text">
              <div class="icon-container">
                <div class="icon-wrapper">
                  <LinkIcon />
                </div>
              </div>
              <span>Release date and source</span>
            </div>
            <div class="separator"></div>
          </div>
          <div
            class="link-type pre-customization"
            :class="{ active: currentStep === 3 }"
          >
            <div class="icon-and-text">
              <div class="icon-container">
                <div class="icon-wrapper">
                  <ViewIcon />
                </div>
              </div>
              <span>Link Customization</span>
            </div>
            <div class="separator"></div>
          </div>
          <div
            class="link-type pre-services"
            :class="{ active: currentStep === 4 }"
          >
            <div class="icon-and-text">
              <div class="icon-container">
                <div class="icon-wrapper">
                  <DashboardIcon />
                </div>
              </div>
              <span>Pre-release Services</span>
            </div>
            <div class="separator"></div>
          </div>
          <div
            class="link-type pre-destinations"
            :class="{ active: currentStep === 5 }"
          >
            <div class="icon-and-text">
              <div class="icon-container">
                <div class="icon-wrapper">
                  <DashboardIcon />
                </div>
              </div>
              <span>Post-release Destinations</span>
            </div>
          </div>
        </template>



        <template v-else>
          <div
            class="link-type source-link"
            :class="{ active: currentStep === 2 }"
          >
            <div class="icon-and-text">
              <div class="icon-container custom-wrapper custom-landing-wrapper">
                <div class="icon-wrapper">
                  <LinkIcon />
                </div>
              </div>
              <span>Source</span>
            </div>
            <div class="separator"></div>
          </div>
          <div
            class="link-type landing-page"
            :class="{ active: currentStep === 3 }"
          >
            <div class="icon-and-text">
              <div class="icon-container custom-wrapper">
                <div class="icon-wrapper">
                  <ViewIcon />
                </div>
              </div>
              <span>Landing Page</span>
            </div>
            <div class="separator"></div>
          </div>
          <div
            class="link-type destinations"
            :class="{ active: currentStep === 4 }"
          >
            <div class="icon-and-text">
              <div class="icon-container custom-wrapper custom-landing-wrapper">
                <div class="icon-wrapper">
                  <DashboardIcon />
                </div>
              </div>
              <span>Destinations</span>
            </div>
          </div>
        </template>



      </div>
    </div>
    <div class="steps-container">
      <CreateLinkWizardStepOne v-if="currentStep === 1" @close="close()" @setStep="setStep" />
      <template v-if="createLinkWizardData.link_type === 'pre-release'">
        <LinkWizardPreReleaseSource v-if="currentStep === 2" action="create" @back="back()" @close="close()"
          @setStep="setStep" />
        <LinkWizardCustomize v-if="currentStep === 3" action="create" :link="{ type: createLinkWizardData.link_type }"
          @back="back()" @close="close()" @setStep="setStep" />
        <LinkWizardPreReleaseServices v-if="currentStep === 4" action="create" @back="back()" @close="close()"
          @setStep="setStep" />
        <LinkWizardPreReleaseFinal v-if="currentStep === 5" action="create" @back="back()" @close="close()"
          @setStep="setStep" @finish="onFinish" />
      </template>
      <template v-else>
        <CreateLinkWizardStepTwo v-if="currentStep === 2" @back="back()" @close="close()" @setStep="setStep" />
        <LinkWizardCustomize v-if="currentStep === 3" action="create" :link="{ type: createLinkWizardData.link_type }"
          @back="back()" @close="close()" @setStep="setStep" />
        <LinkWizardDestinations v-if="currentStep === 4" action="create" @back="back()" @close="close()"
          @setStep="setStep" @finish="onFinish" />
      </template>
    </div>
  </div>
</template>
<script>
import EditIcon from "../../../public/img/icons/edit-gradient.svg";
import LinkIcon from "../../../public/img/icons/link-gradient.svg";
import ViewIcon from "../../../public/img/icons/view-gradient.svg";
import DashboardIcon from "../../../public/img/icons/dashboard-gradient.svg";
import CloseIcon from "../../../public/img/icons/close.svg";
import CreateLinkWizardStepOne from "@/components/Custom/CreateLinkWizardStepOne";
import CreateLinkWizardStepTwo from "@/components/Custom/CreateLinkWizardStepTwo";
import LinkWizardPreReleaseSource from "@/components/Custom/LinkWizardPreReleaseSource";
import LinkWizardCustomize from "@/components/Custom/LinkWizardCustomize";
import LinkWizardPreReleaseServices from "@/components/Custom/LinkWizardPreReleaseServices";
import LinkWizardPreReleaseFinal from "@/components/Custom/LinkWizardPreReleaseFinal";
import LinkWizardDestinations from "@/components/Custom/LinkWizardDestinations";

export default {
  name: "CreateLinkWizard",
  components: {
    EditIcon,
    LinkIcon,
    ViewIcon,
    DashboardIcon,
    CloseIcon,
    CreateLinkWizardStepOne,
    CreateLinkWizardStepTwo,
    LinkWizardPreReleaseSource,
    LinkWizardCustomize,
    LinkWizardPreReleaseServices,
    LinkWizardPreReleaseFinal,
    LinkWizardDestinations,
  },
  data() {
    return {
      currentStep: 1,
    };
  },
  computed: {
    createLinkWizardData() {
      return this.$store.getters.getCreateLinkWizardData;
    },
    artist() {
      return this.$store.getters.getArtist;
    },
    user() {
      return this.$store.getters.getUser;
    },
    isPro() {
      if (
        (!this.artist.current_plan ||
          !this.artist.current_plan.includes("pro")) &&
        !["agency", "family"].includes(this.user.plan)
      ) {
        return false;
      }

      return true;
    },
  },
  methods: {
    setStep(step) {
      this.currentStep = step;
    },
    onFinish(link_id) {
      console.log("finished", link_id);
      this.$emit("finish", link_id);
    },
    back() {
      if (this.currentStep === 1) {
        this.close();
      } else {
        this.currentStep--;
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.create-link-wizard::-webkit-scrollbar {
  display: none !important;
}

.create-link-wizard {
  overflow-y: auto;
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* BG/type1 */
  background: $bg-type-1;



  .wizard-sidebar {
    display: flex;
    margin-top: 66px;
    justify-content: center;

    .progress {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;
      margin: 0 36px;
      .link-type,
      .source-link,
      .landing-page,
      .pre-release,
      .destinations {
        display: flex;
        align-items: center;
        &:not(.active) {
          .icon-and-text {
            .icon-container {
              svg {
                path {
                  fill: $text-type-2;
                }
              }
            }
          }
        }

        &.active {
          .icon-and-text {
            .icon-container {
              background: linear-gradient(46.19deg,
                  #9c27b0 5.66%,
                  #9733ee 94.35%);
            }

            span {
              color: white;
              text-align: center;
            }
          }

          .separator {
            background: linear-gradient(46.19deg,
                #9c27b0 5.66%,
                #9733ee 94.35%);
          }
        }

        .icon-and-text {
          display: flex;
          flex-direction: column;
          align-items: center;
          // min-width: 100px;
          .icon-container {
            width: 46px;
            height: 46px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 1px;
            background: $text-type-2;
            border-radius: 50px;

            .icon-wrapper {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              background: $bg-type-1;
              border-radius: 50px;

              svg {
                width: 24px;
              }
            }
          }

          span {
            margin-top: 6px;
            /* 14/SemiBold */
            font-weight: 600;
            font-size: 14px;
            line-height: 22px;
            /* Text/type2 */
            color: #59588d;
            text-align: center;
          }
        }

        .separator {
          height: 1px;
          width: 36px;
          background: $text-type-2;
          margin-left: 20px;
        }
      }
    }
  }

  .steps-container {
    flex: 1;
    display: flex;
    justify-content: center;
    //overflow-y: scroll;
    padding: 0 40px !important;
  }

  .close {
    cursor: pointer;
    position: fixed;
    top: 15px;
    right: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:hover {
      svg {
        path {
          fill: white;
        }
      }

      .close-text {
        color: white;
      }
    }

    svg {
      width: 18px;
      margin: 3px 0;

      path {
        fill: #8786ab;
      }
    }

    .close-text {
      font-weight: 600;
      font-size: 14px;
      line-height: 10px;
      text-transform: uppercase;
      /* Text/type2 */
      color: $text-type-2;
    }
  }
}
.custom-wrapper {
  // width: 52px !important;
  // height: 52px !important;
  background: #59588d !important;
}

// .custom-landing-wrapper{
// }
.custom-wrapper .icon-wrapper svg path {
  fill: #59588d !important;
}
.active .icon-and-text .custom-wrapper .icon-wrapper svg path {
  fill: #fff !important;
}
.icon-and-text ~ .separator {
  background: #59588d !important;
}
.active .icon-and-text ~ .separator {
  background: #fff !important;
}
.active .icon-and-text .custom-wrapper {
  background: #fff !important;
}
.custome-icons-text {
  // min-width: 105px !important;
}

@media screen and (max-width: 768px) {
  .custom-wrapper {
    width: 30px !important;
    height: 30px !important;
  }

  .create-link-wizard {
    .wizard-sidebar {
      .progress {
        width: 90%;
        gap: 6px;

        .link-type {
          .icon-and-text {
            span {
              display: none;
            }

            .icon-container {
              width: 30px;
              height: 30px;

              .icon-wrapper {
                svg {
                  width: 12px;
                }
              }
            }
          }

          .separator {
            width: 12px;
            margin-left: 6px;
          }
        }
      }
    }

    .close {
      right: 15px;
    }
  }
}

@media (max-width: 768px) {
  .landing-page,
  .source-link,
  .pre-release,
  .destinations,
  .pre-date,
  .pre-customization,
  .pre-services,
  .pre-destinations {
    .icon-and-text {
      min-width: 54px !important;
    }
    span {
      display: none;
    }
  }
}
@media (max-width: 500px) {
  .landing-page,
  .source-link,
  .pre-release,
  .destinations {
    span {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .create-link-wizard {
    .steps-container {
      padding: 0 20px !important;
    }
  }
}

@media screen and (max-width: 870px) {
  .progress {
    padding: 0 10px;
    margin-top: 45px;
  }
}



@media screen and (max-width: 760px) {
  .close {
    z-index: 100;
  }

  .icon-and-text {
    text-align: center
  }
}

@media screen and (max-width: 560px) {
  .close {
    z-index: 100;
  }

  .icon-and-text {
    width: 60px;
    text-align: center
  }

  .icon-and-text span {
    display: none;
  }

  .separator {
    width: 15px !important;
  }

  .icon-container {
    height: 35px !important;
    width: 35px !important;
  }

  .icon-and-text {
    min-width: 0 !important;
  }

}



</style>
